$(function() {
    const popup = {
        init() {
            popup.create();
        },
        create() {
            const popupElement = $('[data-popup-element]'),
                popupContent = $('[data-popup-content]'),
                popupClose = $('[data-popup-content]');

            if (popupContent.length == 0) return;

            popupContent.addClass('w-transition');

            $('body').on('click', '[data-popup-element]', function(event) {
                event.preventDefault();
                const $this = $(this);
                let name = $this.data('name');
                console.log(name);

                if($this.hasClass('on')) {
                    $this.removeClass('on');
                    $('body').removeClass('no-scroll');
                    $('[data-popup-content][data-name="' + name + '"]').removeClass('on');
                } else {
                    if($this.hasClass('in-popup')) {
                        $('[data-popup-content]').not($('[data-popup-content][data-name="' + name + '"]')).removeClass('on');
                    } else {
                        $this.addClass('on');
                    }
                    
                    $('body').addClass('no-scroll');
                    $('[data-popup-content][data-name="' + name + '"]').addClass('on');
                    if(name == 'search') {
                        var x = setTimeout(function() {
                            clearTimeout(x);
                            $('[data-search-term]').focus();
                        }, 400);
                    }
                }

                
            });

            $('body').on('click', '[data-popup-close]', function(event) {
                event.preventDefault();

                let name = $(this).data('name');
                $('body').removeClass('no-scroll');
                $('[data-popup-element][data-name="' + name + '"]').removeClass('on');
                $('[data-popup-content][data-name="' + name + '"]').removeClass('on');
            });

            $('body').on('click', function(event) {
                if($(event.target).parents('.account').length == 0) {
                    if($('.cta-account.on').length > 0) {
                        if($(event.target).parents('[data-popup-element]').length == 0) {
                            $('body').removeClass('no-scroll');
                        }
                        
                        $('[data-popup-element].w-account').removeClass('on');
                        $('[data-popup-content].w-account').removeClass('on');
                        $('[data-popup-content].w-account-details').removeClass('on');
                    }
                }
            });

        },
    };

    popup.init();
});